(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not([data-mt-init])');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.dataset.mtInit = '1'; el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    els.forEach(function (el) { el.dataset.mtInit = '1'; io.observe(el); });
  }

  function initMagneticCards(root) {
    var cards = (root || document).querySelectorAll('.mt-card-mag:not([data-mt-init])');
    cards.forEach(function (card) {
      card.dataset.mtInit = '1';
      if (reduced || window.matchMedia('(hover: none)').matches) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        var px = (x / r.width - 0.5), py = (y / r.height - 0.5);
        card.style.transform = 'perspective(800px) rotateX(' + (-py * 6) + 'deg) rotateY(' + (px * 6) + 'deg)';
        card.style.setProperty('--mx', x + 'px');
        card.style.setProperty('--my', y + 'px');
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(800px) rotateX(0deg) rotateY(0deg)';
      });
    });
  }

  function initFaq(root) {
    var items = (root || document).querySelectorAll('.mt-faq__item:not([data-mt-init])');
    items.forEach(function (item) {
      item.dataset.mtInit = '1';
      var btn = item.querySelector('.mt-faq__pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('mt-open');
        item.closest('.mt-faq__lista').querySelectorAll('.mt-faq__item.mt-open').forEach(function (o) {
          if (o !== item) o.classList.remove('mt-open');
        });
        item.classList.toggle('mt-open', !wasOpen);
      });
    });
  }

  function initPasosLinea(root) {
    var lineas = (root || document).querySelectorAll('.mt-pasos__linea:not([data-mt-init])');
    if (!lineas.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      lineas.forEach(function (el) { el.dataset.mtInit = '1'; el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('mt-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    lineas.forEach(function (el) { el.dataset.mtInit = '1'; io.observe(el); });
  }

  function initAll(root) {
    initReveals(root);
    initMagneticCards(root);
    initFaq(root);
    initPasosLinea(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
